import styled from 'styled-components';

export const AgencyOverviewHeroWrapper = styled.div({
  '.hero-wrapper': {
    img: {
      objectPosition: `center`,
    },
  },
});
